import { render, staticRenderFns } from "./CompareItem.vue?vue&type=template&id=6e6525a1&"
import script from "./CompareItem.vue?vue&type=script&lang=js&"
export * from "./CompareItem.vue?vue&type=script&lang=js&"
import style0 from "./CompareItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSlideXTransition } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VFlex,
  VLayout,
  VSelect,
  VSlideXTransition,
  VTextField,
})
